import React from 'react';
import { FaCircle } from 'react-icons/fa';

interface StatusIndicatorProps {
  status: 'S' | 'N' | 'A'; // Definindo explicitamente que o status pode ser 'S', 'N' ou 'A'
}

const BolinhaTabelaStatus: React.FC<StatusIndicatorProps> = ({ status }) => {
  const color =
    status === 'S' ? '#4fb359' : status === 'N' ? '#ec3f3f' : '#ffbb00';

  return (
    <FaCircle
      style={{
        color,
        fontSize: '1rem',
        width: '100%',
        padding: '0px',
        marginTop: '-6px',
      }}
    />
  );
};

export default BolinhaTabelaStatus;
